import React, { useState } from 'react';
 import AppImage from'./AppImage';
 import Icon from'./AppIcon';

interface AppLogoProps {
  src?: string
  text?: string
  iconName?: string
  size?: number
  className?: string
  onClick?: () => void
}

const AppLogo: React.FC<AppLogoProps> = ({
  src = '/assets/images/app_logo.png',
  text,
  iconName = 'SparklesIcon',
  size = 64,
  className = '',
  onClick,
}) => {
  const [imageError, setImageError] = React.useState(false)

  const handleImageError = () => {
    setImageError(true)
  }

  if (text) {
    return (
      <div
        className={`flex items-center gap-3 cursor-pointer ${className}`}
        onClick={onClick}
      >
        <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
          <Icon name={iconName} size={24} className="text-primary-foreground" />
        </div>
        <span className="font-display font-bold text-2xl tracking-tight text-foreground">
          {text}
        </span>
      </div>
    )
  }

  if (imageError) {
    return (
      <div
        className={`flex items-center gap-3 cursor-pointer ${className}`}
        onClick={onClick}
      >
        <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
          <Icon name={iconName} size={24} className="text-primary-foreground" />
        </div>
        <span className="font-display font-bold text-2xl tracking-tight text-foreground">
          Mulumbu Minerals
        </span>
      </div>
    )
  }

  return (
    <div className={`cursor-pointer ${className}`} onClick={onClick}>
      <AppImage
        src={src}
        alt="Mulumbu Minerals Logo"
        width={size}
        height={size}
        className="object-contain"
        onError={handleImageError}
      />
    </div>
  )
}

export default AppLogo